import ClientSDK from '../App/ClientSDK'
import CustomerTransformer from '../Customer/Client/Transformer'
import { ICustomer } from '../Customer/interfaces/ICustomer'

import { InvoiceLine } from './type'

export interface InvoiceLineDto {
  id: string
  name: string
  amount: number
  unit_price: number
  discount: number
  vat_percentage: number
  line_total: number
}

const mapInvoiceLineToDtoInvoiceLine = (
  data: InvoiceLine[],
): InvoiceLineDto[] => {
  return data.map(
    (invoiceLine): InvoiceLineDto => ({
      id: invoiceLine.id,
      name: invoiceLine.name,
      amount: invoiceLine.amount,
      unit_price: invoiceLine.unitPrice,
      discount: invoiceLine.discount,
      line_total: invoiceLine.lineTotal,
      vat_percentage: invoiceLine.vat,
    }),
  )
}

export const createInvoice = async (
  customer: ICustomer,
  lines: InvoiceLine[],
  receiptId: string | null,
): Promise<string> => {
  const response = await ClientSDK.instance().post<any>('invoice/create', {
    customer: CustomerTransformer.reverseTransform(customer),
    lines: mapInvoiceLineToDtoInvoiceLine(lines),
    receipt_id: receiptId,
  })

return response.data.invoice_id
}
